<lib-breadcrumbs [categoryChain]="categoryChain()" [mainTitle]="category().data.title" />

<h1 class="text-4xl text-center my-6 text-[--color-text-primary]">{{ category().data.title }}</h1>

@if (category()?.data?.parent?.id) {
  <app-articles-list [category]="category()"></app-articles-list>
} @else {
  <app-categories-list [category]="category()"></app-categories-list>
}
